import React from "react";
import {
  Route,
  Routes as RouterRoutes,
  Navigate,
  useLocation,
} from "react-router-dom";

import SessionHelper from "./components/Helper/SessionHelper";
import Callback from "./components/Auth/Callback";

// Import all layouts
import MainLayout from "./layouts/mainLayout";
// AuthLayoutSwitch picks v2 (redesigned chrome) or v1 (legacy MUI Drawer)
// based on the redesign flag — same pattern as SessionsPageSwitch / LoginSwitch.
import AuthLayout from "./layouts/authLayoutSwitch";

// Import Routes Configuration
import RouteConfig from "./constants/RouteConfig";
// Import static pages
import NotFound from "./components/Static/NotFound";
import UnAuthorized from "./components/Static/UnAuthorized";

const MainRoute = ({ component: Component }) => {
  return (
    <MainLayout>
      <Component />
    </MainLayout>
  );
};

const AuthRoute = ({ component: Component, requiredPermissions = [] }) => {
  const location = useLocation();

  if (!SessionHelper.isLoggedIn()) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!SessionHelper.hasPermission(requiredPermissions)) {
    return (
      <MainLayout>
        <UnAuthorized />
      </MainLayout>
    );
  }

  return (
    <AuthLayout>
      <Component />
    </AuthLayout>
  );
};

const AppRoutes = () => (
  <>
  <RouterRoutes>
    <Route path="/callback" element={<Callback />} />
    {RouteConfig.map((route, index) => {
      const { path, component, exact, requiresAuth, requiredPermissions } = route;
      if (requiresAuth) {
        return (
          <Route
            key={index}
            path={path}
            element={<AuthRoute component={component} requiredPermissions={requiredPermissions} />}
          />
        );
      } else {
        return (
          <Route
            key={index}
            path={path}
            element={<MainRoute component={component} />}
          />
        );
      }
    })}
    <Route
      path="*"
      element={
        <MainLayout>
          <NotFound />
        </MainLayout>
      }
    />
  </RouterRoutes>
  </>
);

export default AppRoutes;
